import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';

import {
    withStyles,
    createMuiTheme,
    MuiThemeProvider,
} from '@material-ui/core';

import ThemeVars from './ThemeVars';
import Routes from './Routes';

import Header from './components/Header';
import AppContext from './AppContext';
import Banner from './components/Banner';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withTranslation } from 'react-i18next';

const theme = createMuiTheme({
    palette: {
        primary: { main: ThemeVars.primaryColor },
        secondary: { main: ThemeVars.secondaryColor },

    }
});

const styles = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },

    container: {
        display: 'flex',
        flexGrow: 1
    }
});

class Main extends Component {
    constructor(props) {
        super(props);

        this.callback = () => { };

        this.state = {
            user: null,
            loading: true,
            open: false,
            toastOpen: false,
            bannerOpen: false,
            lastMessage: null,
        };

        this.refreshData = this.refreshData.bind(this);
        this.showDialog = this.showDialog.bind(this);
        this.showToast = this.showToast.bind(this);
        this.handleClose = this.handleClose.bind(this);

        this.showBanner = this.showBanner.bind(this);
        this.messages = [
            this.props.t('Tervetuloa Lukelokiin! Hävikin vähentäminen on selvää säästöä!'),
            this.props.t('Kiva nähdä sinua! Mukavaa että aloitit hävikkikirjauksen!'),
            this.props.t('Teet tärkeää työtä! Hienoa että kirjaat tänään!')
        ];

        this.scope = {
            refreshData: this.refreshData,
            getUser: () => this.state.user
        };
    }

    refreshData() {
        this.setState({ loading: true });

        return AppContext.getUser(true)
            .then((user) => {
                this.setState({
                    user,
                    loading: false
                });
                this.showBanner();
            }).catch((e) => console.log(e));
    }

    showDialog(callback) {
        this.setState({ open: true });
        this.callback = callback;
    }

    showToast(text) {
        this.setState({
            toastOpen: true,
            toastText: text
        });
    }

    showBanner(message, reopen = false) {
        if (this.state.bannerOpen) {
            return null;
        }
        if (reopen == true && this.state.lastMessage) {
            message = this.state.lastMessage;
        }
        if (!message) {
            message = this.messages[Math.floor(Math.random() * this.messages.length)];
        }

        if (this.state.user && this.state.user.restaurant && this.state.user.restaurant.notifications_disabled == false) {
            this.setState({
                bannerOpen: true,
                message: message,
                lastMessage: message,
            });
            this.hideWithTimer();
        }
    }

    hideBanner() {
        this.setState({ bannerOpen: false });
    }

    hideWithTimer() {
        setTimeout(() => {
            this.hideBanner();
        }, 5000);
    }

    handleClose(val) {
        if (val)
            this.callback();

        this.setState({ open: false });
    }

    componentDidMount() {
        this.refreshData();

        AppContext.prompt = this.showDialog;
        AppContext.toast = this.showToast;
        AppContext.banner = this.showBanner;
    }

    render() {
        const { classes } = this.props;

        if (this.state.loading) {
            return null;
        }

        return (
            <MuiThemeProvider theme={theme}>
                <div className={classes.root}>
                    <Header title="Luke"
                        restaurant={this.state.user && this.state.user.restaurant ? this.state.user.restaurant.name : ''}
                        showMenu={this.state.user != null}
                    />

                    <Banner
                        showBanner={this.state.bannerOpen}
                        message={this.state.message}
                    />

                    <main className={classes.container}>
                        <Switch>
                            {
                                Routes.map((route, i) => {
                                    // ISSUE: map's var clonedRoute is a reference?!
                                    // any modifications would affect the next render -- need to clone
                                    const clonedRoute = Object.assign({}, route);
                                    if (!clonedRoute.auth || this.state.user) {
                                        if (clonedRoute.fillScope) {
                                            clonedRoute.render = clonedRoute.component(this.scope);
                                            delete clonedRoute['component'];
                                        }

                                        return <Route key={i} {...clonedRoute} />;
                                    }

                                    return '';
                                })
                            }

                            {
                                this.state.user == null ? <Route component={() => <Redirect to="/login" />} /> : null
                            }
                        </Switch>
                    </main>

                    <Dialog
                        open={this.state.open}
                        onClose={() => this.handleClose(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{this.props.t('Oletko varma')}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {this.props.t('Haluatko varmasti poistaa tämän?')}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.handleClose(false)} color="primary">
                                {this.props.t('En')}
                            </Button>
                            <Button onClick={() => this.handleClose(true)} color="primary" autoFocus>
                                {this.props.t('Kyllä')}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={this.state.toastOpen}
                        onClose={() => this.setState({ toastOpen: false })}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {this.state.toastText}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.setState({ toastOpen: false })} color="primary" autoFocus>
                                {this.props.t('Ok')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </MuiThemeProvider>
        );
    }
}

Main.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withTranslation()(withStyles(styles)(Main));



// WEBPACK FOOTER //
// ./resources/assets/js/Main.js